/**
 * Basit CSV indirme (Excel uyumlu, UTF-8 BOM).
 * @param {string} filename - örn. "para-cekme.csv"
 * @param {string[]} headers - kolon başlıkları
 * @param {Array<Array<string|number|null|undefined>>} rows
 */
export function downloadCsv(filename, headers, rows) {
  const esc = (v) => {
    if (v == null) return "";
    const s = String(v);
    if (/[",\n\r;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const lines = [
    headers.map(esc).join(";"),
    ...rows.map((r) => r.map(esc).join(";")),
  ];
  const bom = "\uFEFF";
  const blob = new Blob([bom + lines.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Obje listesinden CSV (keys = kolon sırası).
 */
export function downloadObjectsCsv(filename, objects, columns) {
  // columns: [{ key, label }]
  const headers = columns.map((c) => c.label);
  const rows = objects.map((obj) =>
    columns.map((c) => {
      const v = typeof c.get === "function" ? c.get(obj) : obj[c.key];
      return v;
    })
  );
  downloadCsv(filename, headers, rows);
}
